import type { Plugin } from "vue";
import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import { Button } from "primevue";
import { VoltexploitPreset } from "~ui/@application/configs/primevue-config.ts";

import PrimeVue from "primevue/config";
import FocusTrap from "primevue/focustrap";
import Ripple from "primevue/ripple";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import "primeicons/primeicons.css";

type TVoltexploitPrimevueConfigurationPluginOptions = {
  config: TAppConfig;
};

export const voltexploitPrimevueConfigurationPlugin = {
  install(app, options: Partial<TVoltexploitPrimevueConfigurationPluginOptions> = {}) {
    void options;

    app.use(PrimeVue, {
      theme: {
        preset: VoltexploitPreset,
        options: {
          darkModeSelector: ".dark",
          cssLayer: {
            name: "primevue",
            order: "theme, base, primevue",
          },
        },
      },
    });

    app.component("Button", Button);
    app.directive("tooltip", Tooltip);
    app.directive("focustrap", FocusTrap);
    app.directive("ripple", Ripple);
    app.use(ToastService);
  },
} satisfies Plugin;
